import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LightGallery from 'lightgallery/vue'
import lgZoom from 'lightgallery/plugins/zoom'
import lgFullScreen from 'lightgallery/plugins/fullscreen'


export default /*#__PURE__*/_defineComponent({
  __name: 'GallerySlider',
  setup(__props) {

const plugins = [lgZoom, lgFullScreen]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LightGallery), {
    settings: {
    speed: 500,
    mobileSettings: {
      controls: false,
      showCloseIcon: true,
      download: true
    },
    getCaptionFromTitleOrAlt: false,
    plugins: plugins
  }
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["settings"]))
}
}

})